//frontend/src/components/AdminRequests/Chat/components/EmojiPicker.jsx

import React from "react";

const EMOJIS = [
  "😀","😂","🤣","😊","😍","🤔","😎","😢","😡","👍",
  "👎","🙏","👏","🔥","❤️","💯","✨","🎉","✅","❌",
  "📎","📷","🎤","📞","💬","👀","🙌","🤝","💪","🤯",
];

export default function EmojiPicker({ onPick, onClose }) {
  return (
    <div className="chat-emoji-picker" onClick={(e) => e.stopPropagation()}>
      {EMOJIS.map((e) => (
        <button
          key={e}
          type="button"
          onClick={() => {
            onPick(e);
            onClose();
          }}
        >
          {e}
        </button>
      ))}
    </div>
  );
}